import Checkbox from 'components/Checkbox';
import Field from 'components/Field';
import createReactClass from 'create-react-class';
import Formsy from 'lib/Formsy';
import * as React from 'react';
import createChainedFunction from 'utils/createChainedFunction';
import { InputChangeHandler } from 'types/typescript/eventHandlers';

type Props = {
  name: string;
  defaultChecked: boolean;
  onChange: InputChangeHandler;
  value: boolean;
}

const FormCheckBox = createReactClass<Props>({
  mixins: [Formsy.Mixin],

  componentDidMount() {
    this.interval = setInterval(this.lookForChanges, 1000);
  },

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  onChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setValue(event.target.checked);
  },

  /* This is for autofill purposes.
   * Some browsers does not emit change event when
   * they fill out the forms, so formzy is not aware
   * the value change and the validation does not run.
   * This pulls the value from the DOM at
   * regular interval and if what is found is different
   * than what formzy currently have then we tell formzy
   * about this new value via the formzy mixin.
   */
  lookForChanges() {
    if (!this.refs.input) {
      return;
    }

    const checked = this.refs.input.isChecked();
    if (checked !== this.getValue()) {
      this.setValue(checked);
    }
  },

  render() {
    const errorMessage = this.getErrorMessage();

    return (
      <Field error={errorMessage}>
        <Checkbox
          {...this.props}
          ref="input"
          onChange={createChainedFunction(this.props.onChange, this.onChange)}
        />
      </Field>
    );
  },
});

export default FormCheckBox;
